export default [
	{
		code: 1,
		city: "آذربایجان شرقی",
	},
	{
		code: 2,
		city: "آذربایجان غربی",
	},
	{
		code: 3,
		city: "همدان",
	},
	{
		code: 4,
		city: "یزد",
	},
	{
		code: 5,
		city: "مرکزی",
	},
	{
		code: 6,
		city: "هرمزگان",
	},
	{
		code: 7,
		city: "لرستان",
	},
	{
		code: 8,
		city: "مازندران",
	},
	{
		code: 9,
		city: "گلستان",
	},
	{
		code: 10,
		city: "گیلان",
	},
	{
		code: 11,
		city: "کرمانشاه",
	},
	{
		code: 12,
		city: "کهکیلویه و بویراحمد",
	},
	{
		code: 13,
		city: "کردستان",
	},
	{
		code: 14,
		city: "کرمان",
	},
	{
		code: 15,
		city: "قزوین",
	},
	{
		code: 16,
		city: "قم",
	},
	{
		code: 17,
		city: "فارس",
	},
	{
		code: 18,
		city: "سمنان",
	},
	{
		code: 19,
		city: "سیستان و بلوچستان",
	},
	{
		code: 20,
		city: "خوزستان",
	},
	{
		code: 21,
		city: "خراسان رضوی",
	},
	{
		code: 22,
		city: "خراسان شمالی",
	},
	{
		code: 23,
		city: "چهارمحال و بختیاری",
	},
	{
		code: 24,
		city: "خراسان جنوبی",
	},
	{
		code: 25,
		city: "بوشهر",
	},
	{
		code: 26,
		city: "تهران",
	},
	{
		code: 27,
		city: "امور خارجه",
	},
	{
		code: 28,
		city: "ایلام",
	},
	{
		code: 29,
		city: "اردبیل",
	},
	{
		code: 30,
		city: "اصفهان",
	},
];
